export const isValidDate = (dateString: string): boolean => {
    if (! /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
        return false
    }

    const parts = dateString.split('/')
    const month = parseInt(parts[0], 10)
    const day = parseInt(parts[1], 10)
    const year = parseInt(parts[2], 10)

    if (year < 1500 || year > 3000 || month === 0 || month > 12) {
        return false
    }

    const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) monthLength[1] = 29

    return day > 0 && day <= monthLength[month - 1]
}
